import React, { createContext, useState, ReactNode } from 'react';
import { ObjectGeneric } from '../../../../../../../utils/types/generals';
import { useParams } from 'react-router-dom';
import { EvidencesFormat } from '../Interfaces';
import { EvidencesTypeValueEnum } from '../../../../../../../utils/enums/evidences';

// Keep existing interfaces
export interface SubcategoryInterface {
  id: number;
  name: string;
  categoryId: number;
  requestText: boolean;
  priorityId: number;
  supplierId: number | null;
  priority: {
    id: number;
    name: string;
  };
  user: {
    id: number;
    curp: string;
    firstName: string;
    lastName: string;
    email: string;
  } | null;
}

export interface CategoryInterface {
  id: number;
  name: string;
  subcategories: SubcategoryInterface[];
}

export interface SelectedSubcategoryInterface {
  id: number;
  name: string;
  categoryName: string;
  priority:{id:number,name:string};
  priorityId:number;
  user: {
    id?: number
    label?: string
  }
}

export interface IdSubOptionInterface {
  areaId:number,
  departmentId:number,
  category:string,
  subCategoryId:number,
  priorityId:number, 
  userAssigned?:number
}

// Internal form data for managing state
interface FormData {
  subcategoryText: string;
  selectedCategory?: {name:string,id:number} | null;
  selectedSubcategories?: SelectedSubcategoryInterface[] | null;
  area?: ObjectGeneric | null;
  department?: ObjectGeneric | null;
  selectedUnit: ObjectGeneric | null;
  selectedPriority: string | null;
  selectedProvider: ObjectGeneric | null;
  selectedProviderCopy: ObjectGeneric | null;
  title: string | null;
  description: string | null;
  categories: CategoryInterface[];
  evidences: EvidencesFormat;
  flag?:boolean;
  flagStep2?:boolean;
  evidencesDataEdit?:{
    evidenceTypeId: EvidencesTypeValueEnum;
    originalName: string;
    url: string;
  }[],
  categoryIdSelected?: number
  idSubOption: IdSubOptionInterface | undefined
}

// Data structure for API submission
export interface SubmitFormData {
  areaId: number;
  departmentId: number;
  categories: {
    categoryId: number;
    category: string;
    subcategoryId: number;
    subcategory: string;
    priorityId: number;
    priority: string;
    requestText: boolean;
    userAssignId: number;
  }[];
  storeId: number;
  priorityId: number;
  userAssignId: number;
  name: string;
  description: string;
  evidences?: any[];
}

interface FormContextType {
  formData: FormData;
  updateFormData: (data: Partial<FormData>) => void;
  id: string | undefined;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setConfig: React.Dispatch<any>
  config: any
  setConfigCopy: React.Dispatch<React.SetStateAction<undefined>>
  configCopy: undefined
}

export const FormContext = createContext<FormContextType>({
  formData: {},
  updateFormData: () => { },
  id: undefined
});

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [formData, setFormData] = useState<FormData>({});
  const { id } = useParams()
  const [isEdit, setIsEdit] = useState(false)
  const [config, setConfig] = useState<any>(null);
  const [configCopy, setConfigCopy] = useState()

  const updateFormData = (newData: Partial<FormData>) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData, id, isEdit, setIsEdit, config, setConfig, configCopy, setConfigCopy }}>
      {children}
    </FormContext.Provider>
  );
};